export const environment = {
  production: false,
  socketApiURL: 'https://socketsapidev.ridequdos.com/',
  socketURL: 'https://socketsdev.ridequdos.com/',
};
